import focusManager from "focus-manager";
import {ToggleScroll} from "@main/components/toggle-scroll";
/** Класс модального окна "Задать вопрос". */
class AskQuestionModal {
    modal = document.querySelector(".js-modal-ask-question")

    buttonSubmit = this.modal.querySelector(".js-form-submit-btn")
    
    documentEl = document.body
    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} el Элемент.
     */
    constructor(el) {
        this.el = el;
        this.openModalButton = this.el.querySelector(".js-ask-question-btn");
        this.listenEvents();
    }

    /**
     * Прослушиваем событие клика на кнопку "Написать".
     * 
     * @returns {void}
     */
    listenEvents() {
        this.openModalButton.addEventListener("click", () => {
            this.modal.classList.add("shown");
            ToggleScroll.disable(this.modal);
            this.buttonSubmit.removeAttribute("disabled");
            focusManager.capture(this.modal);
        });
    }
}

window.addEventListener("load", () => {
    document.querySelectorAll(".js-ask-question").forEach((item) => new AskQuestionModal(item));
});
